import PropTypes from 'prop-types';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import search from '@src/assets/icons/ticketcar/search-normal.svg';

import CustomImage from './CustomImage';

const CustomSearchBar = ({
  placeholder,
  openSearchBar,
  setOpenSearchBar,
  inputRef,
  id,
  filteredText,
  onInputChange,
}) => {
  if (!openSearchBar)
    return (
      <div className="header-notification">
        <CustomImage
          style={{ cursor: 'pointer' }}
          src={search}
          onClick={() => setOpenSearchBar(!openSearchBar)}
        />
      </div>
    );
  return (
    <Input
      ref={inputRef}
      id={id}
      name={id}
      type="text"
      placeholder={placeholder}
      prefix={<SearchOutlined />}
      className="custom-filter-menu-search no-margin"
      value={filteredText}
      onChange={onInputChange}
    />
  );
};

CustomSearchBar.propTypes = {
  placeholder: PropTypes.string,
  openSearchBar: PropTypes.bool,
  setOpenSearchBar: PropTypes.func,
  inputRef: PropTypes.any,
  id: PropTypes.string,
  filteredText: PropTypes.string,
  onInputChange: PropTypes.func,
};

export default CustomSearchBar;
